// src/axios-setup.js
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; 

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    const token = sessionStorage.getItem('token'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

